
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sparkles, X } from "lucide-react";

const Hero2 = () => {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const openModal = (modalId: string) => {
    setActiveModal(modalId);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const handleFormSubmit = () => {
    // FormSubmit will handle the redirect, so we just close the modal
    setTimeout(() => {
      closeModal();
    }, 1000);
  };

  return (
    <>
      <section className="py-16 md:py-24 bg-gradient-to-br from-white to-toctoc-beige/30">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="inline-block bg-toctoc-blue/10 px-4 py-2 rounded-full">
                <p className="text-toctoc-blue font-medium text-sm">
                  Qualidade profissional em minutos. Tecnologia Toc Toc.
                </p>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-toctoc-black leading-tight">
                <span className="text-toctoc-blue">Toc Rápido</span> – Transforme suas fotos em anúncios que vendem
              </h1>
              <p className="text-xl text-toctoc-gray-dark md:pr-12">
                Edição profissional automatizada + acesso exclusivo à fotógrafos especialistas.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Button 
                  size="lg" 
                  className="bg-toctoc-orange hover:bg-toctoc-orange/90 text-white rounded-full px-8 py-6 font-semibold transition-transform hover:scale-105 duration-200"
                  onClick={() => openModal('modal-experimente')}
                >
                  Experimente Agora
                  <Sparkles className="ml-2 h-5 w-5 text-white" />
                </Button>
                <Button 
                  variant="outline" 
                  size="lg" 
                  className="border-toctoc-blue text-toctoc-blue hover:bg-toctoc-blue/5 rounded-full px-8 py-6 font-semibold"
                  onClick={() => openModal('modal-detalhes')}
                >
                  Ver Detalhes
                </Button>
              </div>
            </div>
            <div className="relative hidden md:block">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-toctoc-orange/20 rounded-full z-0"></div>
              <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-toctoc-blue/10 rounded-full z-0"></div>
              <div className="relative z-10 rounded-xl overflow-hidden shadow-2xl border">
                <img 
                  src="https://images.unsplash.com/photo-1524230572899-a752b3835840" 
                  alt="Corretor usando o aplicativo Toc Toc para edição automática de fotos"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute top-3 right-3 bg-toctoc-orange text-white px-2 py-1 rounded text-xs font-medium">
                  100% IA Toc Toc
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal para Experimente Agora */}
      {activeModal === 'modal-experimente' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={closeModal}>
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-toctoc-black">Experimente o Toc Rápido</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <X className="h-5 w-5" />
              </button>
            </div>
            <form 
              action="https://formsubmit.co/toctoctecnologia@gmail.com" 
              method="POST"
              onSubmit={handleFormSubmit}
              className="space-y-4"
            >
              <input 
                name="name" 
                type="text" 
                placeholder="Nome completo" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input 
                name="phone" 
                type="tel" 
                placeholder="Telefone" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input 
                name="email" 
                type="email" 
                placeholder="E-mail" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input name="plano" type="hidden" value="Experimente Agora - Toc Rápido" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="box" />
              <button 
                type="submit" 
                className="w-full bg-toctoc-orange hover:bg-toctoc-orange/90 text-white py-2 px-4 rounded-md font-semibold transition-colors"
              >
                Começar Teste Grátis
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Modal para Ver Detalhes */}
      {activeModal === 'modal-detalhes' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={closeModal}>
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-toctoc-black">Ver Detalhes do Toc Rápido</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <X className="h-5 w-5" />
              </button>
            </div>
            <form 
              action="https://formsubmit.co/toctoctecnologia@gmail.com" 
              method="POST"
              onSubmit={handleFormSubmit}
              className="space-y-4"
            >
              <input 
                name="name" 
                type="text" 
                placeholder="Nome completo" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input 
                name="phone" 
                type="tel" 
                placeholder="Telefone" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input 
                name="email" 
                type="email" 
                placeholder="E-mail" 
                required 
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-toctoc-blue"
              />
              <input name="plano" type="hidden" value="Ver Detalhes - Toc Rápido" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="box" />
              <button 
                type="submit" 
                className="w-full bg-toctoc-blue hover:bg-toctoc-blue/90 text-white py-2 px-4 rounded-md font-semibold transition-colors"
              >
                Receber Informações
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero2;
